import { TextField } from '@automata/ui';
import { ChangeEvent, FocusEvent, useEffect, useState } from 'react';

type Props = {
  label: string;
  value?: number;
  onValidChange: (value: number) => void;
  min?: number;
  fullWidth?: boolean;
};

export const ValidatedNumberField = ({
  label,
  value,
  onValidChange,
  min = 1,
  fullWidth = true,
}: Props) => {
  const [inputValue, setInputValue] = useState<string>(String(value ?? min));

  // Sync local state with prop value when it changes
  useEffect(() => {
    setInputValue(String(value ?? min));
  }, [value, min]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    const numericValue = parseInt(e.target.value, 10);
    if (!isNaN(numericValue) && numericValue >= min) {
      onValidChange(numericValue);
    } else {
      // Reset to original value if invalid
      setInputValue(String(value ?? min));
    }
  };

  return (
    <TextField
      label={label}
      type="number"
      value={inputValue}
      onChange={handleInputChange}
      onBlur={handleBlur}
      slotProps={{ htmlInput: { min } }}
      fullWidth={fullWidth}
    />
  );
};
